module.exports = __webpack_public_path__ + "res/7-img_info_b.48125d49842c9c22c1b681382893daf1.png";